import { authApiHandler } from '../services/authApi'
import type { AuthConfig, AuthData, GetAuthDataOptions } from '../types/types'
import tokenHandler from '../handlers/tokenHandler'
import cookieHandler from '../handlers/cookieHandler'
import { AccessTokenData, IdTokenData } from '../types/tokenTypes'

export default (config: AuthConfig, cookieHeader?: string) => {
  const authApi = authApiHandler(config)
  const token = tokenHandler(config)
  const cookie = cookieHandler(cookieHeader)

  return async (
    code: string,
    options: GetAuthDataOptions = {},
    contactId?: number
  ): Promise<AuthData | null> => {
    const provider = options.provider != null ? options.provider : 'okta'

    const selectedContactId = contactId ?? cookie.getContactId()

    const tokens = await authApi.getTokens(code, provider, selectedContactId)
    if (!tokens) {
      return null
    }

    const validIdTokenData = token.getToken<IdTokenData>(tokens.idToken)
    const validAccessTokenData = token.getToken<AccessTokenData>(tokens.micrositeToken)
    if (!validIdTokenData || !validAccessTokenData) return null

    return {
      accessData: token.getUserData(
        token.getIdTokenProfile(validIdTokenData),
        validAccessTokenData
      ),
      tokens,
      accessTokenData: validAccessTokenData,
      idTokenData: validIdTokenData,
    }
  }
}
